import Tooltip from "@mui/material/Tooltip";

export const ReportsTruncatedName = ({ value, empty = "—" }) => {
  const name =
    value == null || String(value).trim() === "" ? empty : String(value);
  const showTooltip = name !== empty;

  const label = <span className="reports-truncated-name">{name}</span>;

  if (!showTooltip) {
    return label;
  }

  return (
    <Tooltip
      title={name}
      placement="bottom"
      arrow
      PopperProps={{
        modifiers: [
          {
            name: "offset",
            options: { offset: [0, 8] },
          },
        ],
      }}
    >
      {label}
    </Tooltip>
  );
};
